import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { COMPANY } from "@/data/site";
import { useQuote } from "@/components/QuoteModal";

export default function NotFound() {
  const { openQuote } = useQuote();
  return (
    <>
      <Seo title={`Page Not Found | ${COMPANY.brand}`} siteName={COMPANY.brand} description="The page you're looking for doesn't exist." noindex />
      <section className="section-pad bg-white">
        <div className="container-site text-center max-w-xl" data-testid="not-found-page">
          <p className="font-heading font-extrabold text-cts-red text-7xl mb-4">404</p>
          <h1 className="h2-display mb-4">Page Not Found</h1>
          <p className="lead-text mb-8">
            The page you're looking for doesn't exist or has moved. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/" data-testid="notfound-home-btn" className="btn-primary">GO TO HOMEPAGE</Link>
            <button onClick={() => openQuote()} data-testid="notfound-quote-btn" className="btn-outline">GET A QUOTE</button>
            <Link to="/contact" data-testid="notfound-contact-btn" className="btn-outline">CONTACT CTS</Link>
          </div>
        </div>
      </section>
    </>
  );
}
